// extracted by mini-css-extract-plugin
module.exports = {"root":"DashboardWidgets_root__3cCGK"};